/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedUnitCostDto } from '../../models/planned-unit-cost-dto';

export interface GetPlannedUnitCost$Params {
  id: string;
}

export function getPlannedUnitCost(http: HttpClient, rootUrl: string, params: GetPlannedUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedUnitCostDto>> {
  const rb = new RequestBuilder(rootUrl, getPlannedUnitCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedUnitCostDto>;
    })
  );
}

getPlannedUnitCost.PATH = '/v0/plannedUnitCosts/{id}';
